import { render, staticRenderFns } from "./VantArea.vue?vue&type=template&id=24183e95&"
import script from "./VantArea.vue?vue&type=script&lang=js&"
export * from "./VantArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports